import { Typography } from 'antd';
import { FC, ReactChildren, ReactNode } from 'react';
import { BaseType } from 'antd/es/typography/Base';
import { TextProps } from 'antd/es/typography/Text';

const { Text: AntdText, Paragraph } = Typography;

type Props = {
  style?: object;
  children: ReactNode;
  level?: number | any;
  paragraph?: boolean;
  light?: boolean | number;
  type?: BaseType;
  size?: number | string;
} & TextProps;

export const Text: FC<Props> = ({ size, light, style, level, children, paragraph, type, ...props }) => {
  if (level) {
    return (
      <Typography.Title style={style} level={level} {...props}>
        {children}
      </Typography.Title>
    );
  } else {
    if (light) {
      style = { ...style, fontWeight: light === true ? 200 : light };
    }

    if (size) {
      style = { ...style, fontSize: size + 'px' };
    }

    let Component = AntdText;
    if (paragraph) {
      Component = Paragraph;
    }
    return (
      <Component style={style} type={type} {...props}>
        {children}
      </Component>
    );
  }
};

export default Text;
